// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1WmCX","sendOtp":"AuthorizeToLogin_sendOtp__r7sW7"};